import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { UsuarioRolService } from "./usuario-rol.service";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalSeleccionUsuarioComponent } from "src/app/components/core/layouts/modal-seleccion-usuario/modal-seleccion-usuario.component";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";

@Component({
  selector: "app-usuario-rol",
  templateUrl: "./usuario-rol.component.html",
  styleUrls: ["./usuario-rol.component.scss"],
})
export class UsuarioRolComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerUsuarioRol: Array<string>;
  formUsuarioRol: FormGroup;
  selectUsuarioRol: any;
  paginaActual: number;

  // filtros
  filtro: FormGroup;
  public isCollapsed = true;

  // Selects
  usuario: Array<any> = [];
  rol: Array<any> = [];

  constructor(
    private formBuilder: FormBuilder,
    private usuarioRolService: UsuarioRolService,
    private modalService: NgbModal
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;

    this.createForm();
    this.selectUsuarioRol = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerUsuarioRol = [
      "Número identificación",
      "Usuario",
      "Rol",
      "Estado",
      "Acción",
    ];
    this.consultarListas();
    this.onConsultarUsuarioRol(1);
  }

  createForm() {
    this.formUsuarioRol = this.formBuilder.group({
      usuario_id: [null, Validators.required],
      usuario: [null, Validators.required],
      rol_id: [null, Validators.required],
      activo: [true],
    });

    this.filtro = this.formBuilder.group({
      numero_identificacion: [null],
      usuario: [null],
      rol_id: [null],
      activo: [null],
    });
  }

  onConsultarUsuarioRol(page: number) {
    this.usuarioRolService
      .get({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarUsuarioRol(value);
  }

  onAgregarUsuarioRol() {
    this.usuarioRolService
      .create({
        ...this.formUsuarioRol.value,
        activo: 1,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarUsuarioRol(this.paginaActual);
          this.formUsuarioRol.reset();
        }
      });
  }

  onOperarUsuarioRol() {
    if (!this.selectUsuarioRol) {
      this.onAgregarUsuarioRol();
    } else {
      this.onModificarUsuarioRol();
    }
  }

  onCargarUsuarioRol(entry: any) {
    entry.activo = entry.activo ? 1 : 0;
    this.formUsuarioRol.patchValue({
      ...entry,
    });
    this.formUsuarioRol.get("rol_id").disable();
    this.formUsuarioRol.get("usuario_id").disable();
    this.selectUsuarioRol = entry;
  }

  onEliminarUsuarioRol(entry: any) {
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.usuarioRolService.delete(entry).subscribe((resultado) => {
        if (resultado.result) {
          // tslint:disable-next-line:max-line-length
          const index = this.dataTabla.items
            // tslint:disable-next-line:no-shadowed-variable
            .findIndex((e) => {
              if (
                e.usuario_id === entry.usuario_id &&
                e.rol_id === entry.rol_id
              ) {
                return true;
              }
            });
          this.dataTabla.items.splice(index, 1);
          this.selectUsuarioRol = null;
          this.formUsuarioRol.reset();
        }
      });
    });
  }

  onModificarUsuarioRol() {
    this.usuarioRolService
      .update({
        ...this.formUsuarioRol.value,
        usuario_id: this.selectUsuarioRol.usuario_id,
        usuario: this.selectUsuarioRol.usuario,
        rol_id: this.selectUsuarioRol.rol_id,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarUsuarioRol(this.paginaActual);
          this.formUsuarioRol.get("rol_id").enable();
          this.formUsuarioRol.get("usuario_id").enable();
          this.formUsuarioRol.reset();
          this.selectUsuarioRol = null;
        }
      });
  }

  consultarListas() {
    this.usuarioRolService.getRol().subscribe((resultado) => {
      if (resultado.data) {
        this.rol = resultado.data;
      }
    });
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarUsuarioRol(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }
  limpiarCUsuarioRol() {
    this.formUsuarioRol.get("rol_id").enable();
    this.formUsuarioRol.get("usuario_id").enable();
    this.formUsuarioRol.reset();
    this.selectUsuarioRol = null;
    this.createForm();
  }
  onOpenModalStatus() {
    const modalRef = this.modalService.open(ModalSeleccionUsuarioComponent, {
      centered: true,
      size: "xl",
      backdropClass: "light-blue-backdrop",
    });
    modalRef.result
      .then((resultado) => {
        this.formUsuarioRol.get("usuario").patchValue(resultado.usuario);
        this.formUsuarioRol.get("usuario_id").patchValue(resultado.usuario_id);
      })
      .catch((resultado) => {
        this.formUsuarioRol.get("usuario").patchValue(null);
        this.formUsuarioRol.get("usuario_id").patchValue(null);
      });
  }
}
